// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2kmxK","empty":"ModalGraph_empty__QE_xP"};